@switch (columnName) {
  @case ('workPhone') {
    @if (element?.contactInfo) {
      {{ element?.contactInfo.prefix }} {{ element?.contactInfo.phoneNumber }}
    }
    @if (!element?.contactInfo) {
      {{ element?.prefix }} {{ element?.phoneNumber }}
    }
  }
  @case ('email') {
    @if (element?.contactInfo?.email) {
      {{ element?.contactInfo?.email }}
    }
    @if (!element?.contactInfo?.email) {
      {{ element?.email }}
    }
  }
  @case ('edit') {
    <button mat-button (click)="buttonFunctions.edit()">
      <mat-icon>edit</mat-icon>
    </button>
  }
  @case ('delete') {
    <button
      mat-button
      appConfirmDialog
      [confirmEntityName]="element?.name"
      (confirmed)="buttonFunctions.delete()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  }
  @case ('quantityType') {
    {{ element.quantityTypeName }}
  }
  @case ('type') {
    {{ element.purchaserType | translate }}
  }
  @case ('totalPrice') {
    {{ element.totalPrice | currency: ' ' : 'symbol' : '1.2-2' }}
    {{ element.currencyName }}
  }
  @case ('receivers') {
    @for (jobPosition of element.receiversJobPositions; track $index) {
      <div>
        {{ jobPosition.name }}
      </div>
    }
    @for (jobPositionGroup of element.receiversJobPositionGroups; track $index) {
      <div>
        {{ jobPositionGroup.name }}
      </div>
    }
    @for (role of element.receiversRoles; track $index) {
      <div>
        {{ role.name }}
      </div>
    }
  }
  @case ('approvers') {
    @for (jobPosition of element.approversJobPositions; track $index) {
      <div>
        {{ jobPosition.name }}
      </div>
    }
    @for (jobPositionGroup of element.approversJobPositionGroups; track $index) {
      <div>
        {{ jobPositionGroup.name }}
      </div>
    }
    @for (role of element.approversRoles; track $index) {
      <div>
        {{ role.name }}
      </div>
    }
  }
  @case ('accounts') {
    @for (account of element.accounts; track $index) {
      <div>
        {{ account.name }}
      </div>
    }
  }
  @case ('departments') {
    @if (element.departmentsAndGroupsInvalid) {
      <mat-icon
        matTooltip="{{ 'supplierDepartmentChangedErrorDescription' | translate }}"
        matTooltipClass="tooltip"
        class="warn-icon"
      >
        warning
      </mat-icon>
    } @else {
      @for (department of element.departments; track $index) {
        <div>
          {{ department.name }}
        </div>
      }
      @for (departmentGroup of element.departmentGroups; track $index) {
        <div>
          {{ departmentGroup.name }}
        </div>
      }
      @for (department of element.departmentsToDisplay; track $index) {
        <div>
          {{ department.name }}
        </div>
      }
      @for (departmentGroup of element.departmentGroupsToDisplay; track $index) {
        <div>
          {{ departmentGroup.name }}
        </div>
      }
    }
  }
  @case ('favorite') {
    @if (element.isFavorite) {
      <app-ui-button
        buttonType="icon-button"
        class="renew-button favorite-star"
        icon="star"
        (click)="unfavorite()"
      ></app-ui-button>
    }
    @if (!element.isFavorite) {
      <app-ui-button
        buttonType="icon-button"
        class="renew-button unfavorite-star"
        icon="star_border"
        (click)="favorite()"
      ></app-ui-button>
    }
  }
  @default {
    {{ element[columnName] }}
  }
}
